import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=3f981b38&scoped=true&"
import script from "./ModalContent.vue?vue&type=script&lang=js&"
export * from "./ModalContent.vue?vue&type=script&lang=js&"
import style0 from "./ModalContent.vue?vue&type=style&index=0&id=3f981b38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f981b38",
  null
  
)

export default component.exports